"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "categorizeTargetRuns", {
    enumerable: true,
    get: function() {
        return categorizeTargetRuns;
    }
});
function categorizeTargetRuns(targetRuns) {
    const summary = {
        aborted: [],
        failed: [],
        skipped: [],
        success: [],
        running: [],
        pending: [],
        queued: []
    };
    for (const targetRun of targetRuns){
        const { status } = targetRun;
        if (!targetRun.target.hidden) {
            summary[status].push(targetRun.target.id);
        }
    }
    return summary;
}
